/**
 * WorkTableEntry class
 */
export class WorkTableEntry {

    public date: string;
    public start: string;
    public end: string;

    public breakfast: boolean;
    public lunch: boolean;

    /**
     * @method constructor
     * @param date 
     * @param start 
     * @param end 
     */
    constructor(date: string, start: string, end: string) {
        this.date = date;
        this.start = start;
        this.end = end;
    }
}


// WEBPACK FOOTER //
// ./src/models/work_table_entry.ts